import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=405d1b14&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mobile/footer.scss?vue&type=style&index=0&id=405d1b14&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d1b14",
  null
  
)

export default component.exports